import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type * as Fabric from '@postermywall/fabricjs-2';

interface StateProps {
  openPopup?: boolean;
  target: any | null;
}

const initialState: StateProps = {
  openPopup: false,
  target: null,
};

const imageItemPopUpMenu = createSlice({
  name: 'ImageItemPopUpMenu',
  initialState,
  reducers: {
    updateImagePopUpState: (state: StateProps, action: PayloadAction<StateProps>) => {
      state.openPopup = action.payload.openPopup;
      state.target = action.payload.target as Fabric.Image;
    },
  },
});

export const {updateImagePopUpState} = imageItemPopUpMenu.actions;
export const imageItemPopUpMenuReducer = imageItemPopUpMenu.reducer;
